import { Injectable } from '@angular/core';
import {ApiService} from '@xref/ngx';
import {map} from 'rxjs/operators';

export class CoreCompetency {
  tag: String;
  tag_type: String;
  subject: String;
  most_popular: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CompetenciesService {
  constructor(
    private api: ApiService
  ) {}

  competencyMapper = (data: any): CoreCompetency[] => data;

  getCompetencies() {
    return this.api.get('v1/core-competency').pipe(map(this.competencyMapper));
  }
}
